import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TrainingDrawerMenu } from '../TrainingDrawerMenu';
import { faBars } from '@fortawesome/pro-regular-svg-icons';
import Styles from './TrainingMenuMobile.module.less';
import { classes } from '../../../../lib';
import { TrainingDataType } from '../../../../lib/landingPage';
import { Logotype } from '../../../Logotype';

export type TrainingMenuMobileProps = {
    trainingMenu: TrainingDataType;
    showLogo?: boolean;
};

export const TrainingMenuMobile = ({
    trainingMenu,
    showLogo,
}: TrainingMenuMobileProps): JSX.Element => {
    const [drawerMenuVisible, setDrawerMenuVisible] = React.useState(false);

    return (
        <div className="horizontal center-middle td-hidden">
            <div className={classes(Styles.menu, 'horizontal g8')}>
                <FontAwesomeIcon
                    icon={faBars}
                    className={Styles.smallLogo}
                    onClick={() => setDrawerMenuVisible(true)}
                />
                <TrainingDrawerMenu
                    trainingMenu={trainingMenu}
                    visible={drawerMenuVisible}
                    setMenuVisible={setDrawerMenuVisible}
                />
                {showLogo && <Logotype type="DefaultIcon" />}
            </div>
        </div>
    );
};
